import { HttpErrorCode } from '@copera/common/error';
import { useMutation } from '@tanstack/react-query';
import { NotesTranscriptionRequests } from '../../requests/notes-transcription';

export const useTranscriptionNotesMutation = () => {
  const { mutateAsync: startNotes, isLoading: isStartingNotes } = useMutation(
    (data: { channelId: string; audioOnly: boolean }) =>
      NotesTranscriptionRequests.startNotes(data.channelId, data.audioOnly),
    {
      meta: {
        httpErrors: {
          [HttpErrorCode.NOT_FOUND]: 'error.transcriptions.channel_not_found',
          [HttpErrorCode.ALREADY_EXISTS]:
            'error.transcriptions.already_taking_notes',
        },
      },
      onSuccess(newContent) {
        return newContent;
      },
    },
  );

  const { mutateAsync: stopNotes, isLoading: isStopingNotes } = useMutation(
    (data: { channelId: string }) =>
      NotesTranscriptionRequests.stopNotes(data.channelId),
    {
      meta: {
        httpErrors: {
          [HttpErrorCode.NOT_FOUND]: {
            default: 'error.transcriptions.channel_not_found',
            channel: 'error.transcriptions.channel_not_found',
            transcription: 'error.transcriptions.not_taking_notes',
          },
        },
      },
      onSuccess() {
        return true;
      },
    },
  );

  return {
    startNotes,
    isStartingNotes,
    stopNotes,
    isStopingNotes,
  };
};
